import { render, staticRenderFns } from "./CookiePopup.vue?vue&type=template&id=404f3bc3&scoped=true&"
import script from "./CookiePopup.vue?vue&type=script&lang=js&"
export * from "./CookiePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f3bc3",
  null
  
)

export default component.exports